import orderBy from "lodash/orderBy";

export const ypoResourcesConstant = {
    TITLE: "Resources",
    DEFAULT_TOGGLE_LABEL: "Categories",
    POST_TOGGLE_LABEL: "Alphabetical",
    SHOW_MORE: "Show more",
    ADD_NEW_LINK: "Add New Link",
    DELETE_CONFIRMATION_MESSAGE: "Are you sure you want to delete?",
    MY_LEARNING: 'My Learning Journey',
    ABODE_CAPTIVATE_PRIME: 'adobecaptivateprime',
    IS_LMS: 'isLMS',
};

export const ypoResourcesMenuDialogFields = {
    DIALOG_TITLE: "Title",
    DIALOG_LINK: "Url",
    DIALOG_IMAGE: "Image",
    DIALOG_ALT_TEXT: "Alternative Text",
    DIALOG_BUTTON: "Title",
    DIALOG_LABEL: "Label", 
    DIALOG_SSO: "SSO Enabled",
    YES: "Yes",
    NO: "No",
    DIALOG_CATEGORY_LABEL: "Label",
    DIALOG_NEW_CATEGORY_LABEL: "Add New Category",
    DIALOG_NEW_LINK_LABEL: "Add New Link",
    CREATE_NEW_CATEGORY: "Create New Category",
};

export const ypoResourcesCategoryType = {
    IMAGE: "image",
    BUTTON: "button",
    CATEGORY: "category",
    LINK: "link",
};

export const ypoResourcesValidationRules = {
    CATEGORY_TITLE_RULE: [
        v => (!!v && !!(v.trim())) || 'Please enter the title for category.',
    ],
    CATEGORY_LABEL_RULE: [
        v => (!!v && !!(v.trim())) || 'Please enter the label for resource link.',
    ],
    CATEGORY_NAVIGATION_RULE: [
        v => (!!v && !!(v && v.trim())) || "Please enter a valid url.", 
    ],   
    CATEGORY_NAME_MAX_TEXT_LENGTH: 64,
    BUTTON_NAME_MAX_TEXT_LENGTH: 40,
    REQUIRED_RULE: [v => (!!v && !!(v && v.trim())) || ''],
    NAVIGATION_URL_RULE: [
        v => !v || /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(v) || 'Please enter a valid url.',
    ],
};

export const getMappedResourcesByCategories = (resourceData, canEditLinks) => {
    const result = [];
    if (resourceData && resourceData.categories && (canEditLinks || resourceData.resourceLinks)) {
        result.push(...resourceData.categories);
        result.forEach((category) => {
            category.subCategories = resourceData.resourceLinks
                .filter(subCategory => subCategory.resourceCategoryId === category.id && subCategory.isActive);
            category.isActive = !!category.subCategories.length || canEditLinks;
        });
    }
    return result.length ? result : null;
};


export const getAlphabeticallyFilteredResources = (resourceLinks) => {
    const result = [];
    const alphabeticalList = [];
    const alphabetRegex = /^[a-zA-Z]+$/i;
    if (resourceLinks && resourceLinks.length) {
        resourceLinks.forEach((resource) => {
            let linkChar = resource.resourceName.charAt(0);
            if (!alphabetRegex.test(linkChar)) {
                linkChar = resource.resourceName.charAt(1);
            }
            if (!alphabeticalList.includes(linkChar.toUpperCase())) alphabeticalList.push(linkChar.toUpperCase());
        });
        alphabeticalList.forEach((alphabet) => {
            const categoryItem = {
                id: alphabet,
                categoryName: alphabet,
                isActive: true,
                subCategories: orderBy(resourceLinks
                    .filter((resource) => {
                        let linkChar = resource.resourceName.charAt(0);
                        if (!alphabetRegex.test(linkChar)) {
                            linkChar = resource.resourceName.charAt(1);
                        }
                        return linkChar.toUpperCase() === alphabet;
                    }), "resourceName", "asc"),
            };
            result.push(categoryItem);
        });
    }
    return result.length ? orderBy(result, "categoryName", "asc") : null;
};

export const getDefaultResourceModel = () => {
    return {
        id: null,
        type: null,
        navigationUrl: null,
        categoryName: null,
        isActive: false,
        isSSOEnabled: false,
        resourceCategoryId: '',
        alternativeText: '',
        resourceName: '',
        displayOrder: '',
        imageUrl: '',
        label: '',
    };
};